import gsap from 'gsap';
/**
 * JS to run on every page using the child theme.
 */
class CTEKChildTheme extends DrupalBehavior {

  onReady(document) {

    // home block button height fix
    // get the maxHeight using innerHeight() function
    var maxHeight = Math.max.apply(null, $(".homepage-logo-block .field_cta_button a").map(function () {
      return $(this).height();
    }).get());

    // Set the height to all .panel elements
    $(".homepage-logo-block .field_cta_button a").height(maxHeight).css({
      'display': 'flex',
      'align-items': 'center'
    });
    // end home block button height fix

    // Sub menus.
    $('.desktop-nav li.level-1.has-childs').attr('role', 'button');
    $('.desktop-nav li.level-1.has-childs').attr('aria-pressed', false);
    $('.desktop-nav li.level-1.has-childs').on('click', function (event) {
      event.preventDefault();
      $(this).attr('aria-pressed', !$(this).hasClass('active'));
      $(this).toggleClass('active');
    });
    $('.desktop-nav li.level-1.has-childs a').on('click', e => {
      window.location = $(e.target).attr('href');
    })

    // Footer menu accordion.
    $('.field_menus .field_title').on('click', function (event) {
      event.preventDefault();
      console.log('work');
      $(this).parents('.field_menus').toggleClass('active');
    });

    //paragraph banner block button link
    var target_val = "";
    var trg = $(".paragraph-banner-block-link").find("#paragraph-banner-block-link-target").val();
    if (trg == "new") target_val = "_blank";
    $(".paragraph-banner-block-link").find(".field_button_link").find('a').attr("target", target_val);

  }

  onContent(context) {
    super.onReady();

    // Populate the mobile nav layout
    if (!$('.mobile-nav-layer .navigation').length) {
      const mainMenu = $('.header .navigation').clone();

      // Fix double id accesibility.
      mainMenu.find('#block-utilitynavigation').attr('id', 'block-utilitynavigation-mobile').attr('aria-labelledby', 'block-utilitynavigation-menu-mobile');
      mainMenu.find('#block-utilitynavigation-menu').attr('id', 'block-utilitynavigation-menu-mobile');
      mainMenu.find('#block-topnav').attr('id', 'block-topnav-mobile').attr('aria-labelledby', 'block-topnav-menu-mobile');
      mainMenu.find('#block-topnav-menu').attr('id', 'block-topnav-menu-mobile');
      mainMenu.find('.has-childs.level-1[role="button"]').removeAttr('role').removeAttr('aria-pressed');
      mainMenu.appendTo('.mobile-nav-layer');

      // Duplicate Global search
      const global_search = $('.offcanvas .global-search-bar form').clone();
      global_search.appendTo('.mobile-nav-layer');
    }

    // Header mobile menu toggle
    let width = window.innerWidth;

    const openMenu = () => {
      width = window.innerWidth;
      gsap.set(".mobile-nav-layer", {
        display: 'block',
      });
      gsap.to(".mobile-nav-layer", 0.3, {
        x: 0,
        onComplete: () => {
          $('html').addClass('mobile-menu-open');
        }
      });
      $('.menu-toggle').hide();
      $('.mobile-nav-close').css('display', 'block');
      $('.mobile-nav-layer').addClass('active');
    };

    const closeMenu = () => {
      width = window.innerWidth;
      gsap.to(".mobile-nav-layer", 0.3, {
        x: width,
        onComplete: () => {
          if (!$('.mobile-nav-layer').hasClass('active')) {
            setTimeout(() => {
              $('.mobile-nav-layer').css('display', 'none');
            }, 350);
          }
        },
      });
      $('.menu-toggle').show();
      $('.mobile-nav-close').css('display', 'none');
      $('.mobile-nav-layer').removeClass('active');
      $('html').removeClass('mobile-menu-open');
    }

    $('.header .menu-toggle').unbind('click').bind('click', (event) => {
      event.preventDefault();
      openMenu();
    });

    $('.mobile-nav-close').on('click', (event) => {
      event.preventDefault();
      closeMenu();
    });

    // Move sidebar cta bellow header.
    if ($('.field_sidebar_ctas').length > 0) {
      if ($('.no-hero').length > 0) {
        $('.sidebar-cta').addClass('sidebar_cta--no-hero');
      }
      const setDesktopPosition = (margin) => {
        const sidebarCta = document.querySelector('.sidebar-cta');
        if (typeof margin !== 'undefined') {
          sidebarCta.style.marginTop = `${margin}px`;
        } else {
          sidebarCta.style.marginTop = `${(74 + (sidebarCta.getBoundingClientRect().height / 2)) * -1}px`;
        }
      };

      this.enquireRegister('camc_camc.md', () => {
        setDesktopPosition();
      }, () => { });
      this.enquireRegister('camc_camc.sm-max', () => {
        $('.field_sidebar_ctas').detach().prependTo('.main-column');
        setDesktopPosition(0);
      }, () => {
        $('.field_sidebar_ctas').detach().prependTo('.sidebar-column');
        setDesktopPosition();
      });
    }

    // Enable modals.
    MicroModal.init({
      onShow: modal => console.info(`${modal.id} is shown`), // [1]
      onClose: modal => console.info(`${modal.id} is hidden`), // [2]
    });
  }

  enquireRegister(breakpointName, match, unmatch) {
    const breakpoints = this.settings.breakpoints;
    const createHandler = (breakpoint, m, u) => {
      return [
        breakpoint.query,
        {
          match: m,
          unmatch: u,
        }
      ];
    };

    enquire.register.apply(enquire, createHandler(breakpoints[breakpointName], match, unmatch));
  }

}

DrupalBehavior.register('ctek_child_theme', 'global', CTEKChildTheme);
